module.exports = __webpack_public_path__ + "img/10.cb506f7b.jpg";